import { useEffect, useState } from "react";
import  UseApiService  from './../../services/Api.service'
import * as constants from './../../constants/constants'

import { useParams } from 'react-router-dom';

import { message } from 'antd';
import { Container, Row } from "react-bootstrap";

import CustomerHeaderComponent from "../components/customer/CustomerHeader";
import CustomerInformationComponent from "../components/customer/CustomerInformation"
import CustomerDataComponent from "../components/customer/CustomerData";



export default function CustomerPage (){
  const [dataUser,setDataUser] = useState([]);
  const [loading,setLoading] = useState(false);
   const { id } = useParams();

  useEffect(()=>{
    const url = constants.API_USUARIO+id;
    //const url = constants.U_API2+'?opt=usr&ppid='+data;

    setLoading(true);
    UseApiService(url,{method:'GET'})
    .then(({data,error}) =>{
      if(error){
        message.warning('Ocurrio un error: '.error);
      }
      else{
        setDataUser(data.usuario);
      }
    })
    .catch((e)=>{
      console.log(e);
      message.warning('Ocurrio un error:'.e);
    })
    .finally((e)=>{
      setLoading(false);
    });    
  },[id]);


  return(
    <Container className="content">
      <Row>
        <CustomerHeaderComponent data={dataUser} />
        <CustomerInformationComponent data={dataUser} />
        <CustomerDataComponent data={dataUser} />
      </Row>
    </Container>
  );
}